var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCompletedSession && _vm.lastestSessionDate)?_c('span',{staticClass:"latest-session-item"},[_vm._v("\n  "+_vm._s(_vm.lastestSessionDate)+"\n")]):_c('div',[_vm._v("\n  "+_vm._s(_vm.$t('none'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }